import React, { useMemo } from 'react';
import BaseModalComponent from '../BaseModal.component';
import ButtonComponent from '../../Button.component';
import { useTranslation } from 'react-i18next';
import { StyledFooterButtonContainer } from './ControlCreateEditModal';
import { useModalManager } from '../../../hooks/ModalManager.hook';
import styled from 'styled-components';

const StyledConfirmDeleteModalBody = styled.div`
  display: flex;
  flex-flow: column;
  gap: 20px;
  padding: 10px;
  width: 300px;
`;

interface Props extends React.AllHTMLAttributes<HTMLDivElement> {
  confirmDelete: () => void;
  handleClose: () => void;
  section: string;
  customMessage?: string;
}

const ConfirmDeleteModal = ({
  confirmDelete,
  handleClose,
  section,
  customMessage,
}: Props) => {
  const { t } = useTranslation();
  const { closeModal } = useModalManager();
  const renderFooter = useMemo(
    () => (
      <StyledFooterButtonContainer>
        <ButtonComponent handleClick={closeModal}>
          {t('Cancel')}
        </ButtonComponent>
        <ButtonComponent
          handleClick={() => {
            confirmDelete();
            handleClose();
          }}
          customColor="#206FE2"
        >
          {t('Delete')}
        </ButtonComponent>
      </StyledFooterButtonContainer>
    ),
    [confirmDelete],
  );
  return (
    <BaseModalComponent footer={renderFooter} header={t('Delete confirmation')}>
      <StyledConfirmDeleteModalBody>
        <div>
          {t(
            `controlModal.${section}.Do you really want to delete ${section}?`,
          )}
        </div>
        {
          <div>
            {customMessage ||
              t(
                `controlModal.${section}.Attention! This ${section} will be hidden, if it needs to be restored or completely deleted, contact support!`,
              )}
          </div>
        }
      </StyledConfirmDeleteModalBody>
    </BaseModalComponent>
  );
};

export default ConfirmDeleteModal;
